<template>
    <div id="ficheProduit">
        <b-row class="backInfoMain2">

            <menuSave 
                :msg="sendMsg" 
                newBtn 
                :btnSaveDisabled="checkAllField" 
                @new="menuNew()" 
                saveBtn 
                @save="menuSave()" 
                :deleteBtn="checkDeleteBtn"
                @delete="menuDelete(activeObj.itemHdr.id)"
                :msgText="sendMsg2"
                :msgType="getTheme.primary">
            </menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <s-itemList 
                    v-if="itemList"
                    :content="itemList" 
                    :returnValue.sync="activeObj.itemHdr"
                    showField="name" 
                    activeField="isActive" 
                    :selectedItems="activeObj.itemHdr"
                    multiColonne
                    :fields="fields"
                    @getRowdDetail="getRowdDetail"
                    >
                </s-itemList>
            </b-col>
            <!--Fin section de gauche-->
            
<!--****************************************************************************************************************************************************************-->
            
            <!--Section du centre-->
            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="3">
                
                <!--PLU / CodeBarre ################################################################################################-->
                <itemPlu 
                    :leftSize="leftSize" 
                    :Plu1.sync="activeObj.itemHdr.plu1" 
                    :Plu2.sync="activeObj.itemHdr.plu2" 
                    :Plu3.sync="activeObj.itemHdr.plu3"
                    :Plu4.sync="activeObj.itemHdr.plu4" 
                    :Plu5.sync="activeObj.itemHdr.plu5">
                </itemPlu>

                <!--Description ################################################################################################-->
                <itemDescription 
                    :leftSize="leftSize" 
                    :description1.sync      ="activeObj.itemHdr.description1" 
                    :description2.sync      ="activeObj.itemHdr.description2" 
                    :note1.sync             ="activeObj.itemHdr.note1" 
                    :note2.sync             ="activeObj.itemHdr.note2">
                </itemDescription>

                <!--Département ################################################################################################-->
                <itemDept
                    :leftSize="leftSize" 
                    :departmentId.sync="activeObj.itemHdr.departmentId">
                </itemDept>

                <!--Prix ################################################################################################-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">

                        <div class="itemMain">
                            <div class="itemSubTitle cursorPoint">{{$t('i_Price')}}</div>
                            <div class="itemContain">

                            <!--Prix ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                            <itemPrice 
                                :prixSize="prixSize" 
                                :priceDecimal="priceDecimal" 
                                :cost.sync="activeItemInfo.cost" 
                                :deposite.sync="activeItemInfo.deposite" 
                                :itemprice1.sync="activeItemInfo.price1" 
                                :itemprice2.sync="activeItemInfo.price2" 
                                :itemprice3.sync="activeItemInfo.price3" 
                                :itemprice4.sync="activeItemInfo.price4" 
                                :priceGroupId.sync="activeItemInfo.priceGroupId">
                            </itemPrice>

                            <!--Type ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                            <itemTypePrice 
                                :isNegative.sync="activeObj.itemHdr.isNegative" 
                                :isGazPrice.sync="activeObj.itemHdr.isGazPrice" 
                                :isOpen.sync="activeObj.itemHdr.isOpen">
                            </itemTypePrice>
                            
                            <!--Taxes ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                            <itemTaxes 
                                :Tx1.sync="activeItemInfo.isTax1" 
                                :Tx2.sync="activeItemInfo.isTax2" 
                                :Tx3.sync="activeItemInfo.isTax3"
                                :Tx4.sync="activeItemInfo.isTax4" 
                                :Tx5.sync="activeItemInfo.isTax5" 
                                :Tx6.sync="activeItemInfo.isTax6" 
                                :chkSize="chkSize">
                            </itemTaxes>

                            <!--Prix spéciaux ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                            <itemSpecialPrice 
                                :isSpecialPricePercent.sync="activeItemInfo.isSpecialPricePercent" 
                                :specialPrice.sync="activeItemInfo.specialPrice" 
                                :isSpecialPriceNoDate.sync="activeItemInfo.isSpecialPriceNoDate" 
                                :specialPriceDate.sync="activeItemInfo.specialPriceDate" 
                                :chkSize="chkSize"
                                @deletePrice="deletePrice">
                            </itemSpecialPrice>

                            <!--Prix par quantité ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                            <itemPriceByQuantity 
                                :PrixQteQ1.sync="activeItemInfo.priceByQuantityQ1" 
                                :PrixQteQ2.sync="activeItemInfo.priceByQuantityQ2" 
                                :PrixQteQ3.sync="activeItemInfo.priceByQuantityQ3" 
                                :PrixQteP1.sync="activeItemInfo.priceByQuantityP1" 
                                :PrixQteP2.sync="activeItemInfo.priceByQuantityP2" 
                                :PrixQteP3.sync="activeItemInfo.priceByQuantityP3"
                                :PrixPaquet.sync="activeItemInfo.isPackagePrice" 
                                :prixSize="prixSize" 
                                :chkSize="chkSize">
                            </itemPriceByQuantity>


                            <!--Commission ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                            <itemCommission :CommissionA.sync="activeItemInfo.commissionCash" :CommissionP.sync="activeItemInfo.commissionPercent"></itemCommission>

                            </div>
                        </div>

                    </b-col>
                </b-row>

                

            </b-col>

            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="5">

                <!--Inventaire ################################################################################################-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('i_Inventaire')}}</div>
                            <div class="itemContain txtMain">
                                <itemInventaire 
                                    :prixSize="prixSize" 
                                    :QteMag.sync="activeItemInfo.stockQuantity" 
                                    :QteEntrepot.sync="activeItemInfo.warehouseQuantity"
                                    :QteVendu.sync="activeItemInfo.totalSalesQty" 
                                    :QteMC.sync="activeItemInfo.putASideQuantity">
                                </itemInventaire>

                                <!--Format de produit ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                                <itemFormatProduct :prixSize="prixSize" :Format.sync="activeObj.itemHdr.format"></itemFormatProduct>

                                <!--Format de commande +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                                <itemFormatCommande 
                                    :prixSize="prixSize" 
                                    :QteParBoite.sync="activeItemInfo.quantityByBox" 
                                    :CommandeMin.sync="activeItemInfo.minimumOrder"
                                    :QteMin1.sync="activeItemInfo.minQty1" 
                                    :QteMax1.sync="activeItemInfo.maxQty1" 
                                    :QteMin2.sync="activeItemInfo.minQty2" 
                                    :QteMax2.sync="activeItemInfo.maxQty2"
                                    :QteMin3.sync="activeItemInfo.minQty3" 
                                    :QteMax3.sync="activeItemInfo.maxQty3" 
                                    :QteMin4.sync="activeItemInfo.minQty4" 
                                    :QteMax4.sync="activeItemInfo.maxQty4">
                                </itemFormatCommande>

                            </div>
                        </div>
                    </b-col>
                </b-row><!--FIN - Inventaire-->

                <!--Fournisseur ################################################################################################-->
                <itemSuppliers  
                    :leftSize="leftSize" 
                    :CodeFourn1.sync="activeItemInfo.supplierCode1" 
                    :CoutFourn1.sync="activeItemInfo.supplierCost1" 
                    :Fourn1.sync="activeItemInfo.supplier1"
                    :CodeFourn2.sync="activeItemInfo.supplierCode2" 
                    :CoutFourn2.sync="activeItemInfo.supplierCost2" 
                    :Fourn2.sync="activeItemInfo.supplier2"
                    :CodeFourn3.sync="activeItemInfo.supplierCode3" 
                    :CoutFourn3.sync="activeItemInfo.supplierCost3" 
                    :Fourn3.sync="activeItemInfo.supplier3"
                    :CodeFourn4.sync="activeItemInfo.supplierCode4" 
                    :CoutFourn4.sync="activeItemInfo.supplierCost4" 
                    :Fourn4.sync="activeItemInfo.supplier4"
                    :CodeFourn5.sync="activeItemInfo.supplierCode5" 
                    :CoutFourn5.sync="activeItemInfo.supplierCost5" 
                    :Fourn5.sync="activeItemInfo.supplier5">
                </itemSuppliers>

                <!--Options ################################################################################################-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('i_Options')}}</div>
                            <div class="itemContain txtMain">

                                <itemOptions 
                                    :chkSize="chkSize" 
                                    :ValideAge.sync="activeObj.itemHdr.isValidateAge" 
                                    :QteObligatoire.sync="activeObj.itemHdr.isMandatoryQuantity" 
                                    :CadrinRapport.sync="activeObj.itemHdr.isReportCadrin" 
                                    :Poids.sync="activeObj.itemHdr.isWeight" 
                                    :CodePoids.sync="activeObj.itemHdr.isWeightCode" 
                                    :PrtEtiAuto.sync="activeObj.itemHdr.isAutoPrintLabel" 
                                    :Billet.sync="activeObj.itemHdr.isTicket" 
                                    :QteTuile.sync="activeObj.itemHdr.isShowQuantityOnButton" 
                                    :PrintCommande.sync="activeObj.itemHdr.isPrintOrder" 
                                    :QteTaxable.sync="activeObj.itemHdr.taxableQuantity" 
                                    :Consignation.sync="activeObj.itemHdr.bottleDeposite">
                                </itemOptions>

                                <!--Mix and match +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                                <!-- <itemMixAndMatch 
                                    v-if="fromApi" 
                                    :content="fromApi.mixAndMatchList" 
                                    :PrMixMatch1.sync="activeObj.itemHdr.mixAndMatch1" 
                                    :PrMixMatch2.sync="activeObj.itemHdr.mixAndMatch2"
                                    :PrMixMatch3.sync="activeObj.itemHdr.mixAndMatch3" 
                                    :PrMixMatch4.sync="activeObj.itemHdr.mixAndMatch4">
                                </itemMixAndMatch> -->

                                <!--Filtres ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                                <itemFiltre 
                                    :Filtre1.sync="activeObj.itemHdr.filter1" 
                                    :Filtre2.sync="activeObj.itemHdr.filter2" 
                                    :Filtre3.sync="activeObj.itemHdr.filter3"
                                    :Filtre4.sync="activeObj.itemHdr.filter4" 
                                    :Filtre5.sync="activeObj.itemHdr.filter5" 
                                    :Filtre6.sync="activeObj.itemHdr.filter6">
                                </itemFiltre>

                                <!--Lien PLU / Boite ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                                <itemLinkPluBox 
                                    :chkSize="chkSize" 
                                    :Boite.sync="activeObj.itemHdr.isBox" 
                                    :LienBoite.sync="activeObj.itemHdr.boxLink" 
                                    :LienBoiteQte.sync="activeItemInfo.quantityByBox">
                                </itemLinkPluBox>

                                <!--Tare ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                                <itemTare name="tareV" :TareV.sync="activeObj.itemHdr.isVariableTare" :Tare.sync="activeObj.itemHdr.tare" :chkSize="chkSize"></itemTare>

                                <!--Compteur ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                                <itemCompteur 
                                    :prixSize="prixSize" 
                                    :Compteur0.sync="activeItemInfo.counter0" 
                                    :Compteur1.sync="activeItemInfo.counter1" 
                                    :Compteur2.sync="activeItemInfo.counter2"
                                    :Compteur3.sync="activeItemInfo.counter3" 
                                    :Compteur4.sync="activeItemInfo.counter4" 
                                    :Compteur5.sync="activeItemInfo.counter5" 
                                    :Compteur6.sync="activeItemInfo.counter6">
                                </itemCompteur>
                            </div><!--FIN - Contain / Options-->
                        </div>

                    </b-col><!--FIN - Options-->
                </b-row>
            </b-col>
            <!--FIN - Section de droite-->
        </b-row>
    </div>
</template>

<script>

import mapGetter from '@/mixins/getters.js'
import menuSave from '@/components/general/s-menuSave/s-menuSave.vue'
import {dataService} from '@/services'
import store from '@/store'

import itemPlu from '@/components/items/itemPlu/itemPlu'
import itemDescription from '@/components/items/itemDescription/itemDescription'
import itemDept from '@/components/items/itemDept/itemDept'
import itemPrice from '@/components/items/itemPrice/itemPrice'
import itemTypePrice from '@/components/items/itemTypePrice/itemTypePrice'
import itemTaxes from '@/components/items/itemTaxes/itemTaxes'
import itemSpecialPrice from '@/components/items/itemSpecialPrice/itemSpecialPrice'
import itemPriceByQuantity from '@/components/items/itemPriceByQuantity/itemPriceByQuantity'
import itemCommission from '@/components/items/itemCommission/itemCommission'
import itemInventaire from '@/components/items/itemInventaire/itemInventaire'
import itemFormatProduct from '@/components/items/itemFormatProduct/itemFormatProduct'
import itemFormatCommande from '@/components/items/itemFormatCommande/itemFormatCommande'
import itemSuppliers from '@/components/items/itemSuppliers/itemSuppliers'
import itemOptions from '@/components/items/itemOptions/itemOptions'
//import itemMixAndMatch from '@/components/items/itemMixAndMatch/itemMixAndMatch'
import itemFiltre from '@/components/items/itemFiltre/itemFiltre'
import itemLinkPluBox from '@/components/items/itemLinkPluBox/itemLinkPluBox'
import itemTare from '@/components/items/itemTare/itemTare'
import itemCompteur from '@/components/items/itemCompteur/itemCompteur'


export default{
    name: "ficheItem",
    mixins:[mapGetter],
    components: {
        menuSave,
        itemPlu,
        itemDescription,
        itemDept,
        itemPrice,
        itemTypePrice,
        itemTaxes,
        itemSpecialPrice,
        itemPriceByQuantity,
        itemCommission,
        itemInventaire,
        itemFormatProduct,
        itemFormatCommande,
        itemSuppliers,
        itemOptions,
        //itemMixAndMatch,
        itemFiltre,
        itemLinkPluBox,
        itemTare,
        itemCompteur

    },
    data() {
        return{
            filterTxt : '',
            leftSize: 12,
            prixSize:{
                reg: 3,
                xl: 3,
                price: 4
            },
            storeNumber : 0,
            InitialState: {
                itemHdr : {},
                itemDetail : [],
            },
            activeObj:{
                itemHdr : {},
                itemDetail : [],
            },
            originalObj : {},
            fields:[
                {
                    colName: "id",
                    label: "id",
                    show: false,
                },
                {
                    colName: "description1",
                    label: this.$i18n.t('description1'),
                    show: true,
                },
                {
                    colName: "description2",
                    label: this.$i18n.t('description1'),
                    show: true,
                },
            ], 
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            sendMsg2: 'vide', //message a utiliser pour le menu en haut de la page New/Save/Delete
        
        }
    },
    methods: {
        isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
        /**
         * Reinitialise tous les champs de la fiche produit
         */
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
            this.originalObj = this.$CObj(this.activeObj)
        },
        /**
         * Crée un nouveau fiche produit vide
         */
        menuNew(){
            this.resetAll()
        },
        /**
         * Charge les données des produits 
         */
        loadApi() {
            //Charger les items depuis le serveur
            this.sendMsg = '-'
            dataService.getProducts()
            .then(response => {
                if(response == 'OK')
                {
                    this.InitialState.itemHdr = this.addons.itemHdr
                    this.InitialState.itemDetail = this.addons.itemDetail

                    this.resetAll() 
                }
                this.sendMsg = ''
                console.log('La liste des items est chargée depuis le serveur');
                
            })
            .catch(error =>{
                this.sendMsg = ''
                console.log(error);
            })

        },
        /**
         * Sauvegarde la fiche produit
         */
        menuSave(){
            let Item = this.$CObj(this.activeObj.itemHdr)
            let ItemInfo = []
            ItemInfo.push(...this.$CObj(this.activeObj.itemDetail));
            
            let sItem = {itemHdr:Item, itemDetail:ItemInfo }

            console.log(sItem);

            if (sItem.itemHdr.id == 0) //CRÉATION D'UN NOUVEAU
            {
                this.sendMsg = '-'
                dataService.addProduct(sItem)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        this.sendMsg2 ='add Produit OK';
                        this.sendMsg = ''
                        this.resetAll()
                        this.loadApi();
                    } 
                    else {
                        alert('KO')
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if(error.data.data == "") {
                        this.sendMsg2 = error.data.addons.errorFr;
                    }
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                this.sendMsg = '-'
                dataService.updateProduct(sItem)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        if(response.data)
                        {
                            this.sendMsg2 ='update OK'
                            this.resetAll()
                        }
                    }
                    this.sendMsg = ''
                })
                .catch((error) => {
                    this.sendMsg = ''
                    console.log(error);
                    alert('update KO');
                });
            }
            setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        /**
         * Désactive la fiche produit
         * @param {int} id - id du produit
         */
        menuDelete(id){
            if (id != '0')
            {
                this.sendMsg = '-'
                dataService.deleteProduct(id)
                .then((response) => {
                    this.sendMsg = ''
                    console.log(response.data);
                    this.resetAll()
                    this.loadApi();
                })
                .catch((error) => {
                    this.sendMsg = '';
                    console.log(error);
                });
            }
        },
        /**
         * Retourne les détails du produit 
         * @param {int} id - id du produit
         */
        getRowdDetail(id)
        {
            this.sendMsg = '-'
            //Aller chercher les information de l'item
            dataService.getProduct(id)
            .then(response => {
                if(response.statusText == 'OK')
                {
                    this.activeObj.itemHdr = response.data.data.itemHdr //les informations de base de l'item
                    this.activeObj.itemDetail = response.data.data.itemDetail //les informations de l'itemInfo

                    this.originalObj = this.$CObj(this.activeObj)
                }
                this.sendMsg = ''
            })
            .catch(error =>{
                this.sendMsg = ''
                console.log(error);
            })
        },

        /**
         * Detruit le prix spécial
         */
        deletePrice(){
            this.activeObj.itemDetail.specialPrice = 0
            this.activeObj.itemDetail.isSpecialPriceNoDate = true
            this.activeObj.itemDetail.specialPriceDate = ""
            this.activeObj.itemDetail.isSpecialPricePercent = false
        },
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        /**
         * Vérifie s'il ya une modification
         */
        checkAllField() {
            return JSON.stringify(this.originalObj) === JSON.stringify(this.activeObj)
        },
        /**
         * Vérifie si on autorise la désactivation du produit
         */
        checkDeleteBtn() {
            return (this.activeObj.id != 0)
        },
        /**
         * Retourne le payload sauvegardé dans le local
         */
        payload : () => store.getters.getItems,
        /**
         * Retourne la liste des produits du payload
         */
        itemList() {
            let list = this.payload?.data
            return list.map(item => item.itemHdr);
        },
        /**
         * Retourne les valeurs initials de l'item et itemInfo
         */
        addons() {
            let itemHdr = {} //entete de l'item
            let itemDetail = [] //Details de l'item par magasin
            let addons = this.payload?.addons
            if(addons) {
                itemHdr = addons.classes.itemHdr
                itemDetail = addons.classes.itemDetail
            }
            return {itemHdr:itemHdr, itemDetail:itemDetail};
        },
        activeItem() {
            return this.activeObj.itemHdr;
        },
        activeItemInfo() {
            return this.activeObj.itemDetail[this.storeNumber];
        },
        /**
         * Determine le nombre de chiffres après la virgule dans les montants
         */
        priceDecimal() {
            return this.activeObj.itemHdr.isGazPrice ? 3 : 2
        },
        /**
         * Retourne la liste des filtres
         */
        filtreList : () => store.getters.getInventory?.data?.itemFilterList,
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.loadApi() 
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>